import { Box } from "@chakra-ui/react"
import { Selector_nth } from "./Selector_nth"



export const Selector = () =>{


return (
    <Box>
        <Selector_nth/>
    </Box>
)
}